import './style.module.css';

import classNames from 'classnames';
import { Link } from 'gatsby';
import React from 'react';

import { AnyLink } from '../any-link';
import {
	copyright as copyrightStyle,
	header as headerStyle,
	icon as iconStyle,
	noRule as noRuleStyle,
	rule as ruleStyle,
} from './style.module.css';

// @todo pull into a shared component with the contact-us sidebar

interface StaticImageProps {
	url: string | null;
	publicUrl: string | null;
	title: string | null;
}

export interface PageFooterNavigationItem {
	title?: string | null;
	slug?: string | null;
	image?: StaticImageProps | null;
}

export interface PageFooterProps {
	logoImageSource?: string | null;
	logoAltText?: string | null;
	logoLinkHref?: string | null;
	navItems?: {
		company?: ReadonlyArray<PageFooterNavigationItem | null> | null;
		legal?: ReadonlyArray<PageFooterNavigationItem | null> | null;
		socials?: ReadonlyArray<PageFooterNavigationItem | null> | null;
	} | null;
	copyright?: string | null;
	newsletterHero?: boolean;
}

interface PageFooterCategoryProps {
	title: string;
	navItems?: ReadonlyArray<PageFooterNavigationItem | null> | null;
}

const PageFooterCategory = ({ title: categoryTitle, navItems }: PageFooterCategoryProps) => {
	return Array.isArray(navItems) && !!categoryTitle ? (
		<ul>
			<li>{categoryTitle}</li>
			{navItems.map(
				({ title, slug, image }, index) =>
					!!title &&
					!!slug && (
						<li key={`${index}-${slug}`}>
							<AnyLink url={slug as string}>
								{!!image && <img src={image.url} alt={image.title} className={iconStyle} />}
								{title}
							</AnyLink>
						</li>
					)
			)}
		</ul>
	) : (
		<></>
	);
};

export const PageFooter = ({
	logoImageSource,
	logoLinkHref,
	logoAltText,
	navItems,
	copyright,
	newsletterHero,
}: PageFooterProps): JSX.Element => {
	// if NewsletterHero is set, don't emit the top line but keep the spacing
	return (
		<footer>
			<div className={classNames(ruleStyle, newsletterHero && noRuleStyle)} />
			<div className={headerStyle}>
				{!!logoImageSource && (
					<Link to={logoLinkHref ?? '/'}>
						<img src={logoImageSource} alt={logoAltText ?? undefined} />
					</Link>
				)}
				{!!navItems && (
					<nav>
						<PageFooterCategory title="Company" navItems={navItems.company} />
						<PageFooterCategory title="Legal" navItems={navItems.legal} />
						<PageFooterCategory title="Get in touch" navItems={navItems.socials} />
					</nav>
				)}
			</div>
			<div className={copyrightStyle}>{!!copyright && <p>{copyright}</p>}</div>
		</footer>
	);
};
